import { useEffect, useState } from "react";

import { utils } from "@atlaskit/util-service-support";

interface Notification {
    id: string;
    content: {
        message?: string;
        body?: {
            items?: unknown[];
        };
    };
}

interface NotificationGroup {
    id: string;
    notifications: Notification[];
}

interface NotificationsResponse {
    groups: NotificationGroup[];
}

interface NotificationsDrawerProps {
    notificationLogUrl: string;
}

const NotificationsDrawer = ({
    notificationLogUrl
}: NotificationsDrawerProps) => {
    const [groups, setGroups] = useState<NotificationGroup[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchNotifications = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const response =
                    await utils.requestService<NotificationsResponse>(
                        {
                            url: `${notificationLogUrl}/api/3/notification-groups`
                        },
                        {
                            queryParams: {
                                category: "direct",
                                expand: "content.body",
                                limit: 8
                            },
                            requestInit: {
                                credentials: "include",
                                headers: {
                                    "content-type": "application/json",
                                    "Accept-Language": "en",
                                    "x-app-name": "wac-notifications",
                                    "x-app-version": "local"
                                }
                            }
                        }
                    );

                setGroups(response.groups || []);
            } catch (err) {
                setError(
                    err instanceof Error
                        ? err.message
                        : "Failed to fetch notifications"
                );
            } finally {
                setIsLoading(false);
            }
        };

        fetchNotifications();
    }, [notificationLogUrl]);

    if (isLoading) {
        return <div>Loading notifications...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (groups.length === 0) {
        return <div>No notifications</div>;
    }

    return (
        <div>
            {groups.map((group) =>
                group.notifications.map((notification) => (
                    <div key={notification.id}>
                        <h4>{notification.content.message}</h4>
                    </div>
                ))
            )}
        </div>
    );
};

export { NotificationsDrawer };
